import { render, staticRenderFns } from "./InvoiceOrderSeparator.vue?vue&type=template&id=3a3787b2&scoped=true&"
import script from "./InvoiceOrderSeparator.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOrderSeparator.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceOrderSeparator.vue?vue&type=style&index=0&id=3a3787b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3787b2",
  null
  
)

export default component.exports